import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import Carousel from "react-grid-carousel";
import { images, altImages } from "./images";
import { PRIMARY } from "../../../vars/vars";
import "./CarouselRibbon.scss";
import { useAppContext } from "../../../context/AppContext";

const CarouselRibbon = () => {
  const { categories } = useAppContext();
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  const isActive = (category) => {
    const params = new URL(document.location).searchParams;
    return params.has("category") && params.get("category") === category;
  };

  useEffect(() => {
    const handleWindowResize = () => {
      setScreenWidth(getWindowWidth());
    };

    window.addEventListener("resize", handleWindowResize);

    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);

  const getWindowWidth = () => {
    return window.innerWidth;
  };

  return (
    <div className="CarouselWrapper">
      <Carousel
        cols={7}
        rows={1}
        gap={1}
        loop
        hideArrow={screenWidth >= 1200 && categories && categories.length <= 7}
        containerClassName="carousel"
        responsiveLayout={[
          {
            breakpoint: 1200,
            cols: 6,
          },
          {
            breakpoint: 1024,
            cols: 4,
          },
          {
            breakpoint: 767,
            cols: 1,
          },
        ]}
      >
        {categories &&
          categories
            .filter((el) => el !== "#N/D")
            .map((category) => (
              <Carousel.Item key={category}>
                <div className={`carousel__lines ${category}`}>
                  <Link
                    to={{ pathname: "/parts", search: `?category=${category}` }}
                  >
                    <StyledLink
                      isActive={isActive(category)}
                      className="carousel__link"
                    >
                      <StyledImage
                        className={`carousel__image image${category}`}
                        image={images[category]}
                        imageAlt={altImages[category]}
                        isActive={isActive(category)}
                      />
                      <Text className={`carousel__text text${category}`}>
                        {category}
                      </Text>
                    </StyledLink>
                  </Link>
                </div>
              </Carousel.Item>
            ))}
      </Carousel>
    </div>
  );
};

export default CarouselRibbon;
const Text = styled.div`
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;
`;
const StyledLink = styled.div`
  border-radius: 5px;
  width: 130px;
  height: 90px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  background-color: ${(props) => (props.isActive ? PRIMARY : null)};
  color: ${(props) => (props.isActive ? "white" : "black")};
  margin: auto;
  &:hover {
    color: white;
    background-color: ${PRIMARY};
  }
`;
const StyledImage = styled.div`
  width: 40px;
  height: 40px;
  background-image: url(${(props) =>
    props.isActive ? props.imageAlt : props.image});
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  &:hover {
    background-image: url(${(props) => props.imageAlt});
  }
`;
